import { GetConversionLimitResponse } from '@flipster/apis/v1/wallet/type';
import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { Price } from '@flipster/ui';

interface Props {
  convertibleLimit?: GetConversionLimitResponse;
  toCurrency: string | undefined;
  toPrecision: number | undefined;
}

export const ConversionLimitInfo = ({ convertibleLimit, toCurrency, toPrecision }: Props) => {
  return (
    <ul className={limitListStyle}>
      <li className={rowStyle}>
        <p>
          <FormattedMessage id='Convert.r250401.One_time_conversion_limit' />
        </p>
        <Price
          fontType='num4'
          price={convertibleLimit?.oneTimeLimit}
          currency={toCurrency}
          precision={toPrecision}
          toFixed
        />
      </li>
      <li className={rowStyle}>
        <p>
          <FormattedMessage id='Convert.r250401.h_24_conversion_limit' />
        </p>
        <Price
          fontType='num4'
          price={convertibleLimit?.user24hRemainingLimit}
          currency={toCurrency}
          precision={toPrecision}
          toFixed
        />
      </li>
    </ul>
  );
};

// Styles converted from convertForm.module.scss
const limitListStyle = css({
  textStyle: 'Legacy/Body3',
  w: '100%',
  my: '8px',
  mb: '48px',
  color: 'gray.500',
});

const rowStyle = css({
  display: 'flex',
  gap: 8,
  w: '100%',
  '& > div, & > p': {
    flex: 1,
  },
  // legacy list
  position: 'relative',
  pl: 12,
  _before: {
    position: 'absolute',
    content: '"•"',
    top: 0,
    left: 0,
  },
});
